import { useTranslation } from '../../../lib/i18n'
import UserSearch from '../../users/UserSearch'
import Button from '../../common/Button'

export default function SelectParticipants({
  onNext,
  participants,
  onSelectParticipant,
}) {
  const { t } = useTranslation()

  return (
    <div>
      <UserSearch
        selectedUsers={participants}
        onSelectUser={onSelectParticipant}
        selectable
      />
      <div className="flex justify-end mt-6">
        <Button primary onClick={onNext}>
          {t('ui.actions.next')}
        </Button>
      </div>
    </div>
  )
}
